import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0da016ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new_overview" }
const _hoisted_2 = { class: "overview_top" }
const _hoisted_3 = { class: "overview_top_left space_between" }
const _hoisted_4 = { class: "align_center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "account_type" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account_type_shadow" }, null, -1))
const _hoisted_8 = { class: "account_type align_center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align_center" }, [
  /*#__PURE__*/_createTextVNode("可用余额"),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "（充值金额+赠送金额）")
], -1))
const _hoisted_10 = { class: "balance" }
const _hoisted_11 = { class: "balance_t" }
const _hoisted_12 = { class: "overview_top_right space_between align_center" }
const _hoisted_13 = { class: "top_black" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overview_top_line" }, null, -1))
const _hoisted_15 = { class: "top_black" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overview_top_line" }, null, -1))
const _hoisted_17 = { class: "overview_middle wt" }
const _hoisted_18 = { class: "middle_con" }
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = { class: "item_box" }
const _hoisted_21 = { class: "item_top" }
const _hoisted_22 = { class: "space_between" }
const _hoisted_23 = { class: "item_top_title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "购买", -1))
const _hoisted_25 = { class: "align_center space_between mt" }
const _hoisted_26 = {
  key: 0,
  class: "item_top_use"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(已使用)", -1))
const _hoisted_28 = {
  key: 1,
  class: "item_top_use"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(已使用)", -1))
const _hoisted_30 = {
  key: 2,
  class: "item_top_use"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(已使用)", -1))
const _hoisted_32 = {
  key: 3,
  class: "item_top_use"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(已使用)", -1))
const _hoisted_34 = { class: "item_img" }
const _hoisted_35 = {
  key: 0,
  class: "item_top"
}
const _hoisted_36 = {
  key: 1,
  class: "img_icon"
}

import { computed, ref } from 'vue';
import { message, Progress, Tooltip } from 'ant-design-vue';
import { useStore } from 'vuex';
import user from '@/api/user';
import http from '@/api/resource';
import CDelModal from '@/components/CDelModal.vue';
import { getNewVerRoleIcon } from '@/utils/common';
import { RedoOutlined, CaretUpOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { useRouter } from 'vue-router';
import type { INewInfoList, overviewType } from './type';
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewSummary',
  setup(__props) {

const aProgress = Progress;
const aTooltip = Tooltip;
const store = useStore();
const userData = computed(() => store.state.user.userInfo);
const router = useRouter();
const homeStore = useHomeStore();

const overviewData = ref<overviewType>({
  role: '', //账户类型
  income: 0, //收益余额
  balance: '', //可用余额
  yesterday_income: 0, // 昨日收益
  real_balance: '', //充值金额
  give_balance: '', //赠送金额
});
const iconPath = ref();
const grade = ref('弱');

const getAccountInfo = useDebounce(() => {
  http.getAccountNew().then((res) => {
    const data = res.data.data;
    overviewData.value = data;
    iconPath.value = getNewVerRoleIcon(data.role_id);
  });
});
getAccountInfo();
// 账户安全等级
const buildInfo = () => {
  user.buildInfo().then((res) => {
    let data = res.data.data;
    grade.value = data.grade;
  });
};
buildInfo();

// 转到余额
const balanceModal = ref(false);
const openDelModal = () => {
  balanceModal.value = !balanceModal.value;
};
const openBalanceModal = () => {
  overviewData.value.income > 0 ? (balanceModal.value = true) : '';
};
const transferBalance = () => {
  message.destroy();
  const income = (overviewData.value as any).income;
  if (Number(income) == 0) {
    message.error('转入金额不能为空');
    balanceModal.value = false;
  } else {
    const data = {
      amount: income,
    };
    http
      .transferInBalance(data)
      .then((res) => {
        message.success(res.data.message);
        getAccountInfo();
      })
      .finally(() => {
        balanceModal.value = false;
      });
  }
};

const NewResourceInfoList = ref<INewInfoList[]>([]);
const getResourceOverview = () => {
  http.getNewResourceOverview().then((res) => {
    const resData = res.data.data;
    let list: any[] = [];
    Object.keys(resData).forEach((e, index) => {
      resData[e].progressBg = squareInfoList(e).progressBg;
      resData[e].showBtn = squareInfoList(e).showBtn;
      resData[e].bg_icon = getListIcon(index);
      list.push(resData[e]);
    });
    NewResourceInfoList.value = list;
    const percent1 = ((list[0].used / list[0].total) * 100).toFixed(2);
    NewResourceInfoList.value[0].percent = Number(percent1);
    const percent2 = ((list[1].used_num / list[1].live_num) * 100).toFixed(2);
    NewResourceInfoList.value[1].percent = Number(percent2);
  });
};
getResourceOverview();

const squareInfoList = (item: any) => {
  let data = { showBtn: false, progressBg: '' };
  if (item === 'store' || item === 'live_num') {
    data.showBtn = true;
    data.progressBg = item === 'store' ? '#00CCB0' : '#F89337';
  } else {
    data.showBtn = false;
    data.progressBg = '';
  }
  return data;
};

const getListIcon = (index: number) => {
  const list = [
    'new_summary_line1',
    'new_summary_line2',
    'new_summary_line3',
    'new_summary_line4',
    'new_summary_line5',
    'new_summary_line6',
    'new_summary_line7',
  ];
  if (index < 7) {
    return list[index];
  } else {
    return list[index % 7];
  }
};

const clickBuy = () => {
  router.push({
    path: '/wallet/resource',
  });
};
const clickToBill = () => {
  router.push('/wallet/bill/');
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "account_avatar",
              src: _unref(userData).avatar,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, "版本：" + _toDisplayString(overviewData.value?.role), 1),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, "账户安全等级：" + _toDisplayString(grade.value), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(_toDisplayString(overviewData.value?.balance) + "元 ", 1),
              _createElementVNode("span", _hoisted_11, " （ " + _toDisplayString(overviewData.value.real_balance) + " + " + _toDisplayString(overviewData.value.give_balance) + " ）", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "color_blue",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(getAccountInfo) && _unref(getAccountInfo)(...args)))
            }, [
              _createTextVNode("刷新 "),
              _createVNode(_unref(RedoOutlined))
            ]),
            (_unref(homeStore).funcData?.WalletRecharge)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/wallet/recharge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("充值")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", null, [
              _createTextVNode(" 收益余额：" + _toDisplayString(overviewData.value?.income) + "元 ", 1),
              _createVNode(_unref(aTooltip), null, {
                title: _withCtx(() => [
                  _createTextVNode(" 有定制微信支付的情况下，将会没有收益余额。")
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" 昨日收益：" + _toDisplayString(overviewData.value?.yesterday_income) + "元 ", 1),
              (Number(overviewData.value?.yesterday_income) > 0)
                ? (_openBlock(), _createBlock(_unref(CaretUpOutlined), { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_16,
        _createElementVNode("div", {
          class: _normalizeClass(overviewData.value?.income > 0 ? 'color_blue' : 'color_base'),
          onClick: openBalanceModal
        }, "转到余额", 2)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(NewResourceInfoList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "middle_item",
                key: item.type
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1),
                      (item.showBtn && item?.buy_status && _unref(homeStore).funcData?.ResourcePurchase)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            class: "align_center mod_btn_primary",
                            size: "small",
                            onClick: clickBuy
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_svg_icon, {
                                class: "mod_nav_btn_icon",
                                "icon-class": "purchase"
                              })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!item.showBtn && item.type !== 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "color_blue",
                            onClick: clickToBill
                          }, "详情"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (item.type === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createTextVNode(_toDisplayString(item.used) + _toDisplayString(item.unit), 1),
                            _hoisted_27
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createTextVNode(_toDisplayString(item.used_num) + _toDisplayString(item.unit), 1),
                            _hoisted_29
                          ]))
                        : _createCommentVNode("", true),
                      (item.type > 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createTextVNode(_toDisplayString(item.used_n) + _toDisplayString(item.unit), 1),
                            _hoisted_31
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createTextVNode(_toDisplayString(item.used_n) + _toDisplayString(item.unit), 1),
                            _hoisted_33
                          ]))
                        : _createCommentVNode("", true),
                      (item.type !== 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            style: _normalizeStyle({ color: item.grow_status === 1 ? '#F53F3F' : item.grow_status === 2 ? '#6DA476' : '' })
                          }, [
                            _createTextVNode(_toDisplayString(item.proportion) + " ", 1),
                            (item.grow_status === 1)
                              ? (_openBlock(), _createBlock(_component_svg_icon, {
                                  key: 0,
                                  "icon-class": "new_summary_rise"
                                }))
                              : _createCommentVNode("", true),
                            (item.grow_status === 2)
                              ? (_openBlock(), _createBlock(_component_svg_icon, {
                                  key: 1,
                                  "icon-class": "new_summary_drop"
                                }))
                              : _createCommentVNode("", true)
                          ], 4))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (item.showBtn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_unref(aProgress), {
                            percent: item.percent,
                            showInfo: false,
                            strokeColor: item.progressBg
                          }, null, 8, ["percent", "strokeColor"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_svg_icon, {
                            "icon-class": item.bg_icon
                          }, null, 8, ["icon-class"])
                        ]))
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(CDelModal, {
      visible: balanceModal.value,
      centered: "",
      close: openDelModal,
      ok: transferBalance
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将收益余额转到余额，是否确定？")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})